/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_DescriptionInputs */

const en_about_description = /** @type {(inputs: About_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more about our mission and how we can help you`)
};

const es_about_description = /** @type {(inputs: About_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conoce nuestra mision y como podemos ayudarte`)
};

/**
* | output |
* | --- |
* | "Learn more about our mission and how we can help you" |
*
* @param {About_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const about_description = /** @type {((inputs?: About_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_description(inputs)
	return es_about_description(inputs)
});